import { useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import QuemSomos from './components/QuemSomos';
import Servicos from './components/Servicos';
import Portfolio from './components/Portfolio';
import Processo from './components/Processo';
import Depoimentos from './components/Depoimentos';
import Formulario from './components/Formulario';
import Footer from './components/Footer';
import { 
  getOrganizationSchema, 
  getWebPageSchema, 
  getServiceSchema, 
  getFAQSchema 
} from '../../utils/seo';

export default function Home() {
  useEffect(() => {
    // Add multiple Schema.org JSON-LD scripts
    const schemas = [
      getOrganizationSchema(),
      getWebPageSchema(),
      getServiceSchema(),
      getFAQSchema()
    ];

    const scriptIds = schemas.map((schema, index) => {
      const scriptId = `schema-org-jsonld-${index}`;
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.text = JSON.stringify(schema);
      script.id = scriptId;
      
      const existingScript = document.getElementById(scriptId);
      if (existingScript) {
        existingScript.remove();
      }
      
      document.head.appendChild(script);
      return scriptId;
    });

    return () => {
      scriptIds.forEach(scriptId => {
        const scriptToRemove = document.getElementById(scriptId);
        if (scriptToRemove) {
          scriptToRemove.remove();
        }
      });
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <QuemSomos />
      <Servicos />
      <Portfolio />
      <Processo />
      <Depoimentos />
      <Formulario />
      <Footer />
    </div>
  );
}
